/* Afsennah - currency-correct thresholds on the cart.

   Product prices all go through Liquid's money filter, so they convert on their own.
   A threshold ("free delivery over 100") is a business rule, not a price: money
   formats it without converting it, and Liquid cannot convert at all. So where the
   merchant has set real numbers for the shopper's country the Liquid side has already
   done the work; everywhere else the markup carries the shop-currency amounts and this
   file converts them with Shopify's own rate, then finishes the ladder the server
   deliberately left blank rather than guess at. */
(function () {
  if (window.afs2Amounts) return;

  function currency() {
    var C = (window.Shopify && window.Shopify.currency) || {};
    var rate = parseFloat(C.rate);
    if (!C.active || !isFinite(rate) || rate <= 0) return null;
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: C.active,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    } catch (e) {
      return null; // currency code Intl does not know - leave the page as rendered
    }
    return { rate: rate, money: function (cents) { return fmt.format(Math.round(cents) / 100); } };
  }

  /* Any element carrying a shop-currency amount gets it converted and reformatted. */
  window.afs2Amounts = function () {
    var nodes = document.querySelectorAll('[data-afs2-amt]');
    if (!nodes.length) return;
    var C = currency();
    if (!C) return;
    Array.prototype.forEach.call(nodes, function (el) {
      var base = parseFloat(el.getAttribute('data-afs2-amt'));
      if (!isFinite(base)) return;
      el.textContent = C.money(base * C.rate);
    });
  };

  /* The reward ladder, for a currency the merchant has not mapped. The server renders
     the shape but claims nothing - no progress, no unlocked - because it cannot compare
     a converted threshold against this cart. Here we can. */
  window.afs2Ladder = function () {
    var L = document.querySelector('[data-afs2k-ladder][data-live]');
    if (!L) return;
    var C = currency();
    if (!C) return;

    var t1 = Math.round(parseFloat(L.getAttribute('data-t1')) * C.rate);
    var t2 = Math.round(parseFloat(L.getAttribute('data-t2')) * C.rate);
    var sub = parseFloat(L.getAttribute('data-sub'));
    if (!isFinite(t1) || !isFinite(t2) || !isFinite(sub)) return;
    if (t2 < t1) t2 = t1;

    var one = t1 === t2;
    var l1 = L.getAttribute('data-l1') || '';
    var l2 = L.getAttribute('data-l2') || '';
    var join = L.getAttribute('data-join') || ' + ';
    var unlocked = L.getAttribute('data-unlocked') || '';

    var nextAt = 0, nextLabel = '';
    if (sub < t1) { nextAt = t1; nextLabel = one ? (l1 + join + l2) : l1; }
    else if (sub < t2) { nextAt = t2; nextLabel = l2; }

    function fill(tpl, amount, label) {
      return (tpl || '').replace('[amount]', C.money(amount)).replace('[reward]', label.toLowerCase());
    }

    var head = L.querySelector('[data-afs2k-ladder-t]');
    if (head) {
      head.innerHTML = nextAt
        ? fill(L.getAttribute('data-away'), nextAt - sub, nextLabel)
        : (L.getAttribute('data-done') || '');
    }

    var bar = L.querySelector('.afs2k-ladder__fill');
    if (bar) bar.style.width = Math.min(100, t2 ? (sub / t2 * 100) : 0) + '%';

    var marks = L.querySelectorAll('.afs2k-ladder__m');
    var at = one ? [t1] : [t1, t2];
    Array.prototype.forEach.call(marks, function (mark, i) {
      if (at[i] === undefined) return;
      var b = mark.querySelector('b');
      if (b) b.textContent = C.money(at[i]);
      var hit = sub >= at[i];
      mark.classList.toggle('is-hit', hit);
      var em = mark.querySelector('em');
      if (hit && !em && unlocked) {
        em = document.createElement('em');
        em.textContent = unlocked;
        mark.appendChild(em);
      } else if (!hit && em) {
        em.parentNode.removeChild(em);
      }
    });

    var sticky = document.querySelector('[data-afs2k-sticky-t]');
    if (sticky) {
      sticky.textContent = nextAt
        ? fill(L.getAttribute('data-sticky-away'), nextAt - sub, nextLabel)
        : (L.getAttribute('data-sticky-done') || '');
    }

    /* Two summary rows the server left alone for the same reason. */
    var shipRow = document.querySelector('[data-afs2k-shiprow]');
    if (shipRow && sub >= t1) {
      var free = shipRow.getAttribute('data-free');
      var b2 = shipRow.querySelector('b');
      if (b2 && free) b2.textContent = free;
      shipRow.classList.add('is-free');
    }
    var giftRow = document.querySelector('[data-afs2k-giftrow]');
    if (giftRow && !one && sub >= t2) giftRow.hidden = false;
  };

  function run() { window.afs2Amounts(); window.afs2Ladder(); }
  window.afs2Refresh = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
